import { type FC, useMemo } from 'react';
import type { DiscountProps } from '../../price.types';
import { cn } from '../../../../../../utils/cn';
import { Text } from '../../../../../../atoms/text';
import { getDiscountPercent } from '../../price.helper';

import styles from '../../discount.module.css';

export const DiscountConfigurable: FC<DiscountProps> = ({ variant, basePrice, product, variantSize }) => {
    const sizeClass = useMemo(() => variantSize && styles[variantSize], [variantSize]);

    const variantClass = useMemo(() => variant === 'horizontal' && styles.minHeight, [variant]);

    const containerClass = useMemo(() => cn(styles.flex, sizeClass, variantClass), [sizeClass, variantClass]);

    return (
        <div className={containerClass}>
            <Text
                className={cn(
                    styles.basePrice,
                    variant === 'details' && styles.detailsBasePrice,
                    variant === 'horizontal' && styles.horizontalBasePrice,
                    variant === 'vertical' && styles.verticalBasePrice
                )}
            >
                {basePrice}
            </Text>
            <Text
                className={cn(
                    styles.discount,
                    variant === 'horizontal' && styles.horizontalDiscount,
                    variant === 'details' && styles.detailsDiscount
                )}
            >
                -{`${getDiscountPercent(product).toFixed(0)}%`}
            </Text>
        </div>
    );
};
